import { ArrowDownRight, ArrowUpRight } from 'lucide-react'

export function TitleHeading({ title, children, className, Icon, ...props }) {
    return (
        <h1 className={`text-xl font-bold pl-3 flex items-center gap-1 ${className}`} {...props}> {Icon && <Icon />}  {children ? children : title}</h1>
    )
}

// export function KPI({ icon: Icon, label, value, sublabel, stateLable, positive, positiveIcon = true, onClick = () => { } }) {
//     return (
//         <div className="bg-white border border-[#E1E4EA] shadow rounded-[14px] p-4 hover:shadow-md transition cursor-pointer" onClick={onClick}>
//             <div className="flex items-center justify-between">
//                 <span className="text-base text-gray-500">{label}</span>
//                 <Icon className="h-5 w-5 text-gray-400" />
//             </div>
//             <div className="mt-2 text-2xl font-bold flex items-center justify-between gap-2">
//                 {value}
//                 {positive != null && (
//                     <span
//                         className={`flex items-center text-xs px-2 py-0.5 rounded-full ${positive
//                             ? "bg-green-100 text-green-700"
//                             : "bg-red-100 text-red-700"
//                             }`}
//                     >

//                         {
//                             positiveIcon ? (
//                                 positive ? (
//                                     <ArrowUpRight className="h-3 w-3 mr-1" />
//                                 ) : (
//                                     <ArrowDownRight className="h-3 w-3 mr-1" />
//                                 )
//                             ) : null
//                         }
//                         {stateLable}
//                     </span>
//                 )}
//             </div>

//             <div className="text-xs text-gray-500 mt-1">{sublabel}</div>
//         </div>
//     );
// }

export function KPI({ icon: Icon, label, value, sublabel, stateLable, positive, positiveIcon = true, onClick = () => { }, tag: Tag, isTag = false, extraClass }) {
    const extraClasses = {
        red: "border-l-[4px] border-l-[#ef4444] bg-[linear-gradient(to_right,#fef2f2_0%,white_20%)]",
        green: "border-l-[4px] border-l-[#10b981] bg-[linear-gradient(to_right,#ecfdf5_0%,white_20%)]",
        yellow: "border-l-[4px] border-l-[#f59e0b] bg-[linear-gradient(to_right,#fffbeb_0%,white_20%)]",
        theme: "border-l-[4px] border-l-[#0B54FF]"
    }
    const extraTextClasses = {
        red: "!text-[#ef4444]",
        green: "!text-[#10b981]",
        yellow: "!text-[#f59e0b]",
        theme: "!border-b-[2px] border-b-[#f2f3f5]"
    }
    // border-bottom: 2px solid #f2f3f5;
    return (
        <div className={`bg-white border border-[#E1E4EA] shadow rounded-[14px] p-4 hover:shadow-md transition cursor-pointer ${extraClass ? extraClasses[extraClass] : ""}`} onClick={onClick}>
            <div className="flex items-center justify-between">
                <span className="text-[13px] text-[#6b7280] font-[500]">{label}</span>
                <Icon className="h-5 w-5 text-gray-400" />
            </div>
            <div className={`mt-2 text-[32px] text-[#1a1a2e] font-bold flex items-center justify-between gap-2 py-[10px] ${extraClass ? extraTextClasses[extraClass] : ""}`}>
                {/* {value} */}
                {value?.toString()?.includes("$") ?
                    <span>
                        <span className='text-[18px] font-[500] opacity-70 pr-[2px]'>$ </span>
                        {value?.toString()?.replaceAll("$", "")}
                    </span>
                    :
                    value
                }
                {positive != null && (
                    <span
                        className={`flex items-center text-[13px] px-2 py-0.5 rounded-full ${positive
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                            }`}
                    >

                        {
                            positiveIcon ? (
                                positive ? (
                                    <ArrowUpRight className="h-3 w-3 mr-1" />
                                ) : (
                                    <ArrowDownRight className="h-3 w-3 mr-1" />
                                )
                            ) : null
                        }
                        {stateLable}
                    </span>
                )}
                {isTag &&
                    <Tag />
                }
            </div>
            <div className="text-[12px] text-[#9ca3af] mt-[6px]">{sublabel}</div>
        </div>
    );
}

export const Card = ({ className = "", children }) => (
    <div className={`w-full border border-[#E1E4EA] shadow rounded-[14px] flex flex-col bg-white 1darkbg-slate-900 ${className}`}>{children}</div>
);
export const CardHeader = ({ className = "", children }) => (
    <div className={`p-4 md:p-5 border-b border-slate-100 1darkborder-slate-800 ${className}`}>{children}</div>
);
export const CardTitle = ({ className = "", children }) => (
    <h3 className={`text-lg md:text-xl font-semibold tracking-tight ${className}`}>{children}</h3>
);
export const CardContent = ({ className = "", children }) => (
    <div className={`p-4 md:p-5 w-full h-full ${className}`}>{children}</div>
);